<template>
  <!-- ICON -->
  <template v-if="icon">
    <v-icon v-if="! hasAccess" size="1em" :title="availabilityMessage" v-bind="$attrs">svgicon-crown-star</v-icon>
  </template>

  <!-- SECTION -->
  <template v-else>
    <slot v-if="hasAccess"></slot>
    <slot v-else name="noaccess">
      <div class="tada-hover d-inline-block" v-bind="$attrs">
        <!-- TEAM -->
        <premium-section-card v-if="feature == 'invite-users'" inline class="mt-3" @open-premium="openPremium()">
          <template #title><b>{{ $t('PREMIUM.INVITE_CONTRIBUTORS') }}</b></template>
        </premium-section-card>
        <premium-section-card v-else-if="feature == 'integrations' || feature == 'integrations-in-element'" :desc="$t('PREMIUM.INTEGRATIONS_IS_PREMIUM')" block @open-premium="openPremium()">
          <template #title v-if="feature == 'integrations-in-element'"><div class="d-flex align-center"><v-icon start>far fa-share-alt</v-icon>{{ $t('ACCOUNT.INTEGRATIONS') }}</div></template>
        </premium-section-card>
        <premium-section-card v-else-if="feature == 'webcalendar'" :desc="$t('PREMIUM.WEBCALENDAR_IS_PREMIUM')" block @open-premium="openPremium()">
        </premium-section-card>
        <premium-section-card v-else-if="feature == 'selection'" block class="text-center" pack="TEAM" @open-premium="openPremium()">
          <template #img><img src="./features/selection.png" style="width: 100%"></template>
        </premium-section-card>

        <!-- BUSINESS -->
        <premium-section-card v-else-if="feature == 'import-csv'" :desc="$t('PREMIUM.BUSINESS.IMPORT_IS_BUSINESS')" pack="BUSINESS" @open-premium="openPremium()">
          <template #img><img src="./features/import-csv.png"></template>
        </premium-section-card>
        <premium-section-card v-else-if="feature == 'import-template'" :desc="$t('PREMIUM.BUSINESS.IMPORT_IS_BUSINESS')" pack="BUSINESS" @open-premium="openPremium()">
          <template #img><img src="./features/import-template.png"></template>
        </premium-section-card>
        <premium-section-card v-else-if="feature == 'business-config'" :desc="$t('PREMIUM.BUSINESS.SECTION_IS_BUSINESS')" pack="BUSINESS" @open-premium="openPremium()">
          <template #img><img src="./features/personnalisation.png"></template>
        </premium-section-card>
        <premium-section-card v-else-if="feature == 'business-tools'" :desc="$t('PREMIUM.BUSINESS.SECTION_IS_BUSINESS')" pack="BUSINESS" @open-premium="openPremium()">
          <template #img><img src="./features/outils-projets.png"></template>
        </premium-section-card>
        <premium-section-card v-else-if="feature == 'groups'" :desc="$t('PREMIUM.BUSINESS.SECTION_IS_BUSINESS')" pack="BUSINESS" @open-premium="openPremium()">
        </premium-section-card>
        <premium-section-card v-else-if="feature == 'recurrence'" block class="text-center" pack="BUSINESS" @open-premium="openPremium()">
          <template #title><div></div></template>
          <template #img><img src="./features/recurrence.png" style="width: 100%"></template>
        </premium-section-card>

        <!-- ENTERPRISE -->
        <premium-section-card v-else-if="feature == 'automations'" :desc="$t('PREMIUM.ENTERPRISE.SECTION_IS_ENTERPRISE')" pack="ENTERPRISE" @open-premium="openPremium()">
          <template #img><img src="./features/automations.png"></template>
        </premium-section-card>
        <premium-section-card v-else-if="feature == 'risks'" :desc="$t('PREMIUM.ENTERPRISE.SECTION_IS_ENTERPRISE')" pack="ENTERPRISE" @open-premium="openPremium()">
        </premium-section-card>
        <premium-section-card v-else-if="feature == 'subprojects-manager'" block class="py-4 text-center px-sm-16" pack="ENTERPRISE" @open-premium="openPremium()">
        </premium-section-card>

        <!-- DASHBOARDS -->
        <premium-section-card v-else-if="feature == '/analysis/progress'" :desc="$t('PREMIUM.DASHBOARDS_IS_PREMIUM')" pack="TEAM" @open-premium="openPremium()">
          <template #img><img src="./features/analysis-progress.png" style="max-width: 600px;"></template>
        </premium-section-card>
        <premium-section-card v-else-if="feature == '/analysis/planningusers'" :desc="$t('PREMIUM.DASHBOARDS_IS_PREMIUM')" pack="TEAM" @open-premium="openPremium()">
          <template #img><img src="./features/analysis-planningusers.png" style="max-width: 600px;"></template>
        </premium-section-card>
        <premium-section-card v-else-if="feature == '/analysis/actions'" :desc="$t('PREMIUM.DASHBOARDS_IS_PREMIUM')" pack="TEAM" @open-premium="openPremium()">
          <template #img><img src="./features/analysis-actions.png" style="max-width: 600px;"></template>
        </premium-section-card>
        <premium-section-card v-else-if="feature == '/analysis/portfolio'" :desc="$t('PREMIUM.DASHBOARDS_IS_PREMIUM')" pack="TEAM" @open-premium="openPremium()">
          <template #img><img src="./features/analysis-portfolio.png" style="max-width: 600px;"></template>
        </premium-section-card>
        <premium-section-card v-else-if="feature == '/analysis/personalcalendar'" :desc="$t('PREMIUM.BUSINESS.DASHBOARD_IS_BUSINESS')" pack="BUSINESS" @open-premium="openPremium()">
          <template #img><img src="./features/analysis-personalcalendar.png" style="max-width: 600px;"></template>
        </premium-section-card>
        <premium-section-card v-else-if="feature == '/dashboards/monitoringplan'" :desc="$t('PREMIUM.ENTERPRISE.SECTION_IS_ENTERPRISE')" pack="ENTERPRISE" @open-premium="openPremium()">
          <template #img><img src="./features/dashboards-monitoringplan.png" style="max-width: 600px;"></template>
        </premium-section-card>

        <!-- MODALS -->
        <v-dialog v-else-if="feature == 'subprojects'" :model-value="true" :max-width="960" content-class="tada-hover" @update:model-value="close">
          <premium-section-card :desc="$t('PREMIUM.SUBPROJECT_IS_PREMIUM')" pack="TEAM" class="flex-row" @open-premium="openPremium()">
            <template #img><img src="./features/subprojects.png"></template>
          </premium-section-card>
        </v-dialog>
        <v-dialog v-else-if="feature == 'macro'" :model-value="true" :max-width="960" content-class="tada-hover" @update:model-value="close">
          <premium-section-card pack="BUSINESS" class="flex-row" @open-premium="openPremium()">
            <template #img><img src="./features/macro.png"></template>
          </premium-section-card>
        </v-dialog>
      </div>
    </slot>
  </template>
</template>

<script>
  import useUiNavigationStore from '@/stores/ui/navigation';
  import useUsersAccessRightStore from '@/stores/users/accessRight';
  import PremiumSectionCard from './PremiumSectionCard.vue';
  import { hasAccessToPremiumFeature, getPremiumFeaturePack } from './PremiumFeatures';

  export default {
    inheritAttrs: false,
    components: {
      PremiumSectionCard,
    },
    props: {
      feature: { type: String, required: true },
      icon: { type: Boolean, default: false }, // mode icon : show premium icon if needed
    },
    emits: ['close'],
    data() {
      return {
        uiNavigationStore: useUiNavigationStore(),
        usersAccessRightStore: useUsersAccessRightStore(),
      };
    },
    computed: {
      hasAccess() {
        return hasAccessToPremiumFeature(this.feature);
      },
      availabilityMessage() {
        const pack = getPremiumFeaturePack(this.feature);
        return pack ? this.$t('PREMIUM.AVAILABLE_IN_PACK', { pack }) : '';
      },
      isPremium() { return this.usersAccessRightStore.isPremium; },
    },
    methods: {
      openPremium() {
        if (! this.isPremium) {
          this.uiNavigationStore.setOpenedModal('premium-window');
        } else {
          // open new tab to my account page
          window.open('https://bubbleplan.net/mon-compte#premium', '_blank');
        }
      },
      close() {
        this.$emit('close');
      },
    },
  };
</script>
